<script>
import resources from './resources'

export default {
  name: 'invite-professional',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row
    form.col-xs-12.col-sm-10.col-sm-offset-1
      h4 ADICIONE UM PROFISSIONAL AO CORPO CLÍNICO DO ESTABELECIMENTO
      .form-group
        .row
          .col-xs-12.col-sm-6.col-md-4.margin-bottom
            label(for='entidade-de-classe') Entidade de Classe
            .input-group
              select#entidade-de-classe.form-control(name='Entidade de Classe')
                option(value='', disabled='', selected='') Selecione
                option(value='CRM', selected="selected") CRM
              span.input-group-addon.blue-addon
                span.icon 
          .col-xs-12.col-sm-6.col-md-4.margin-bottom
            v-input(:status="$v.invite.document.$error ? 'error' : null")
              f-text(label="Número de Registro"
                ref="professinalDocument",
                v-model="invite.document",
                name="document",
                :errors="errors['document']")

          .col-xs-12.col-sm-6.col-md-4.margin-bottom
            v-input(:status="$v.invite.state.$error ? 'error' : null")
              f-select-state(label="UF",
                v-model="invite.state",
                name="state",
                :searchable="true",
                :errors="errors['state']")

      //-.form-group
        .row.text-center
            i.fa.fa-circle-o-notch.fa-spin(style='font-size:24px; color: #ed193b')
            br
            strong Aguarde checando dados do profissional

      .form-group
        .row
          .col-xs-12.col-sm-8.col-md-6.margin-bottom
            v-input(:status="$v.invite.name.$error ? 'error' : null")
              f-text(label="Nome Completo"
                  v-model="invite.name",
                  name="name",
                  :errors="errors['name']")

          .col-xs-12.col-sm-8.col-md-6.margin-bottom
            v-input(:status="$v.invite.email.$error ? 'error' : null")
              f-text(label="E-mail do Profissional"
                    v-model="invite.email",
                    name="email",
                    :errors="errors['email']"
                    placeholder="E-mail")
      //-.form-group(v-if="existProfessonal")
        .row
          .col-xs-12.col-sm-8.col-md-12.margin-bottom
            .alert.alert-danger-alt.alert-dismissable
              span.glyphicon.glyphicon-certificate
              strong Já existe um profissional cadastrado no Medibook com este CRM.

      .buttons-wrapper
        button.btn.cancel(data-dismiss='modal')
          span.icon 
          |  Cancelar
        button.btn.save-filled(@click.prevent="doSaveInvite")
          span.icon 
          |  Adicionar Profissional
</template>



// WEBPACK FOOTER //
// src/app/professional/company/staffs/form/components/invite/invite.vue